import { render } from "./VisualTabs.vue?vue&type=template&id=7f97ee8a&scoped=true"
import script from "./VisualTabs.vue?vue&type=script&lang=ts"
export * from "./VisualTabs.vue?vue&type=script&lang=ts"

import "./VisualTabs.vue?vue&type=style&index=0&id=7f97ee8a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7f97ee8a"

export default script